import { render } from "./SVGLogo.vue?vue&type=template&id=882fb730"
import script from "./SVGLogo.vue?vue&type=script&lang=js"
export * from "./SVGLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__